import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },

  {
    path: '/usulanLokasiAbsen',
    name: 'usulanLokasiAbsen',
    component: () => import('../views/verifikasiLokasiAbsen/usulanLokasiAbsen.vue'),
    beforeEnter: isLoggedIn,
  },





  
  
  {
    path: '/kuesioner',
    name: 'kuesioner',
    component: () => import('../views/kuesioner.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/permintaan_layanan',
    name: 'permintaan_layanan',
    component: () => import('../views/permintaan_layanan.vue'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },
  
  
  {
    path: '/masterLevel',
    name: 'masterLevel',
    component: () => import('../views/dataMaster/masterLevel.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/masterKuesioner',
    name: 'masterKuesioner',
    component: () => import('../views/dataMaster/masterKuesioner.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterKuesionerEvaluasi',
    name: 'masterKuesionerEvaluasi',
    component: () => import('../views/dataMaster/masterKuesionerEvaluasi.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/LPSE_evaluasi',
    name: 'LPSE_evaluasi',
    component: () => import('../views/LPSE/evaluasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/pengelola_valiadasi',
    name: 'pengelola_valiadasi',
    component: () => import('../views/LPSE/valiadasi.vue'),
    beforeEnter: isLoggedIn,
  },












]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
